export enum Direction {
  Dashboard,
  Payment,
}

export const WhereToGo = (): Direction => {
  const location = document.location;

  if (matchDashboard(location)) {
    return Direction.Dashboard;
  }

  return Direction.Payment;
};

const matchDashboard = (location: Location): boolean => {
  if (location.pathname.startsWith("/pay/")) {
    return false;
  }

  return true;
};
